(() => {
  'use strict';

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Failsafe: [data-reveal] content starts at opacity:0 and is only revealed by
     the observer below. If anything between here and there throws, that content
     would stay invisible forever — so schedule an unconditional reveal now and
     cancel it once the observer is actually wired up. */
  let revealReady = false;
  setTimeout(() => {
    if (revealReady) return;
    document.querySelectorAll('[data-reveal]').forEach((el) => el.classList.add('is-visible'));
  }, 2000);

  /* ============================================================
     ANNOUNCEMENT BAR — EDIT THESE TWO THINGS
     ------------------------------------------------------------
     PROMO_MESSAGES : what scrolls across the top of every page.
     PROMO_ID       : bump this string whenever you post a NEW
                      announcement. Anyone who dismissed the old
                      one will see the new one.
     ============================================================ */
  const PROMO_ID = 'tempo-2026-09-a';
  const PROMO_MESSAGES = [
    '1XX Drop is Live.',
    'Join the list — drops land in your inbox first'
  ];

  (function promoBar() {
    const bar = document.querySelector('[data-promo]');
    if (!bar || !PROMO_MESSAGES.length) return;

    const KEY = 'tempo_promo_dismissed';
    let dismissed = null;
    try { dismissed = localStorage.getItem(KEY); } catch (_) {}
    if (dismissed === PROMO_ID) return; // stays hidden

    const esc = (s) => String(s).replace(/[&<>"']/g, (c) =>
      ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]));

    const item = (m, hidden) =>
      `<span class="promo__item"${hidden ? ' aria-hidden="true"' : ''}>` +
      `${esc(m)}<i class="promo__sep"></i></span>`;
    const base   = PROMO_MESSAGES.map((m) => item(m, false)).join('');
    const repeat = PROMO_MESSAGES.map((m) => item(m, true)).join('');

    // Unhide first: the group has to be laid out before it can be measured.
    bar.hidden = false;
    const track = bar.querySelector('[data-promo-track]');

    /* The translateX(-50%) loop only looks continuous while one group is at
       least as wide as the viewport. Below that, empty bar scrolls through
       between the end of the second group and the start of the first. Three
       messages happened to clear it; two do not (648px against a 1059px
       viewport), and a wide enough monitor would have broken three as well.
       So the group repeats itself until it covers the viewport. The repeats
       are aria-hidden — a screen reader should hear each message once. */
    track.innerHTML = `<div class="promo__group">${base}</div>`;
    const first = track.firstElementChild;
    for (let i = 0; i < 8 && first.getBoundingClientRect().width < window.innerWidth; i += 1) {
      first.insertAdjacentHTML('beforeend', repeat);
    }
    const group = first.innerHTML;

    // second copy is decorative — it exists only so translateX(-50%) loops
    track.innerHTML =
      `<div class="promo__group">${group}</div>` +
      `<div class="promo__group" aria-hidden="true">${group}</div>`;

    bar.querySelector('[data-promo-close]').addEventListener('click', () => {
      bar.hidden = true;
      try { localStorage.setItem(KEY, PROMO_ID); } catch (_) {}
    });
  })();

  /* ---- mobile nav ---- */
  const toggle = document.querySelector('.nav__toggle');
  const mobileNav = document.querySelector('.nav__mobile');
  const scrim = document.querySelector('[data-nav-scrim]');
  if (toggle && mobileNav) {
    const closeNav = () => {
      toggle.setAttribute('aria-expanded', 'false');
      mobileNav.classList.remove('is-open');
      if (scrim) { scrim.classList.remove('is-open'); scrim.hidden = true; }
      document.body.style.overflow = '';
    };
    const openNav = () => {
      // The promo bar sits above the sticky header and can be dismissed,
      // so the header's offset is not a constant — measure it each time.
      const nav = document.querySelector('.nav');
      const top = nav ? Math.max(0, nav.getBoundingClientRect().bottom) : 0;
      mobileNav.style.top = top + 'px';
      if (scrim) { scrim.hidden = false; scrim.style.top = top + 'px'; requestAnimationFrame(() => scrim.classList.add('is-open')); }
      toggle.setAttribute('aria-expanded', 'true');
      mobileNav.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    };
    toggle.addEventListener('click', () => {
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';
      isOpen ? closeNav() : openNav();
    });
    mobileNav.querySelectorAll('a').forEach((a) => a.addEventListener('click', closeNav));
    if (scrim) scrim.addEventListener('click', closeNav);
    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeNav();
    });
  }

  /* ---- hero background video ----
     Autoplay is left to the browser (muted + playsinline is what makes it
     allowed), so the video runs without JS. This only handles the cases the
     markup cannot: pausing for anyone who asks for reduced motion, and not
     burning battery/data while the hero is off screen. */
  (function heroVideo() {
    const vid = document.querySelector('[data-hero-video]');
    if (!vid) return;

    if (prefersReducedMotion) {
      vid.removeAttribute('autoplay');
      vid.pause();
      /* The poster cannot stand in here any more: this edit opens on black, so
         the poster is black, which is right for a seamless start and useless as
         a still. Hold on a frame a second in instead, which is the same picture
         the video would have shown — no motion, but not an empty hero. */
      const still = () => { try { vid.currentTime = 1; } catch (_) {} };
      if (vid.readyState >= 1) still();
      else vid.addEventListener('loadedmetadata', still, { once: true });
      return;
    }

    let inView = true;

    /* The title card. The video no longer has `loop`, so it ends, this shows,
       and then it restarts the video — that is what makes the loop now, and it
       is also why the card has to clear itself unconditionally: if it ever
       failed to, the hero would be a black box for the rest of the visit. */
    const sting = document.querySelector('[data-hero-sting]');
    // Words in, words out, mark unfurls, mark holds. The CSS owns the whole
    // timeline (see .hero__sting in style.css); this only needs to outlast
    // it, so the mark is not yanked mid-wipe. The wipe finishes at 2980ms, so
    // everything past that is the mark sitting on its own — about two seconds,
    // which is what makes it land as the end of the sequence rather than a
    // frame the video happens to pass through on its way back to the top.
    const STING_HOLD = 5000;

    vid.addEventListener('ended', () => {
      if (!sting) { vid.currentTime = 0; vid.play().catch(() => {}); return; }

      sting.classList.add('is-on');
      window.setTimeout(() => {
        sting.classList.remove('is-on');
        vid.currentTime = 0;
        // Only actually restart if the hero is still on screen; the observer
        // below starts it again if the visitor scrolls back up.
        if (inView) {
          const p = vid.play();
          if (p && p.catch) p.catch(() => {});
        }
      }, STING_HOLD);
    });

    // play only while the hero is actually in view
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          inView = e.isIntersecting;
          if (e.isIntersecting) {
            // not while the card is up — that is a deliberate pause, and
            // resuming here would cut the line off mid-animation
            if (sting && sting.classList.contains('is-on')) return;
            const p = vid.play();
            if (p && p.catch) p.catch(() => {}); // blocked autoplay: poster stays
          } else {
            vid.pause();
          }
        });
      }, { threshold: 0.1 });
      io.observe(vid);
    }
  })();

  /* ---- scroll reveal ---- */
  const revealEls = document.querySelectorAll('[data-reveal]');
  if (revealEls.length) {
    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      revealEls.forEach((el) => el.classList.add('is-visible'));
    } else {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const delay = Number(entry.target.dataset.revealDelay || 0);
              setTimeout(() => entry.target.classList.add('is-visible'), delay);
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
      );
      revealEls.forEach((el) => io.observe(el));
    }
    revealReady = true;
  }

  /* Catalog filtering lives in shop.js — it must bind after the
     product grids are rendered from data. */

  /* ---- signup forms (front-end only — no backend wired yet) ---- */
  document.querySelectorAll('[data-signup-form]').forEach((form) => {
    // .form-msg is a sibling of the form, not a child — check the parent too
    const msg = form.querySelector('.form-msg') ||
                (form.parentElement && form.parentElement.querySelector('.form-msg'));
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const input = form.querySelector('input[type="email"]');
      if (!input || !input.value || !input.checkValidity()) {
        input && input.reportValidity();
        return;
      }
      if (msg) msg.classList.add('is-visible');
      form.reset();
    });
  });

  /* ---- profile questionnaire ----
     Front-end only: answers persist to this browser via localStorage.
     Wiring this to Shopify customer metafields (or Klaviyo profile
     properties) is what makes it follow the shopper across devices. */
  (function profileForm() {
    const form = document.querySelector('[data-profile-form]');
    if (!form) return;

    const KEY = 'tempo_profile_v1';
    const panel = document.querySelector('[data-profile-saved]');
    const dl = panel && panel.querySelector('dl');
    const esc = (s) => String(s).replace(/[&<>"']/g, (c) =>
      ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]));

    const LABELS = {
      displayName: 'Name', email: 'Email', pronouns: 'Pronouns',
      genres: 'Genres', bpm: 'Home BPM', frequency: 'Out how often',
      heardFrom: 'Found us via', wants: 'Here for', artists: 'On repeat',
      age: 'Age range', city: 'Where you’re at'
    };

    function collect() {
      const data = {};
      new FormData(form).forEach((v, k) => {
        if (!String(v).length) return;
        if (data[k] === undefined) data[k] = v;
        else data[k] = [].concat(data[k], v);
      });
      return data;
    }

    function restore(d) {
      form.querySelectorAll('input, select').forEach((el) => {
        const v = d[el.name];
        if (v === undefined) return;
        if (el.type === 'checkbox') el.checked = [].concat(v).includes(el.value);
        else if (el.type === 'radio') el.checked = el.value === v;
        else el.value = v;
      });
    }

    function summarise(d) {
      if (!dl) return;
      dl.innerHTML = Object.keys(LABELS)
        .filter((k) => d[k] && [].concat(d[k]).length)
        .map((k) => `<div><dt>${LABELS[k]}</dt><dd>${esc([].concat(d[k]).join(', '))}</dd></div>`)
        .join('');
    }

    /* ---- step through it one question at a time ----
       Hidden steps still contribute to FormData (they are display:none, not
       disabled), so collect() below is unchanged. Validation has to run per
       step, though — the browser cannot report on a field it cannot show. */
    const steps = [...form.querySelectorAll('[data-quiz-step]')];
    let stepAt = 0;
    let showStep = () => {};

    if (steps.length) {
      const labelEl = form.querySelector('[data-quiz-label]');
      const barEl = form.querySelector('[data-quiz-bar]');
      const fillEl = form.querySelector('[data-quiz-fill]');
      const backBtn = form.querySelector('[data-quiz-back]');
      const nextBtn = form.querySelector('[data-quiz-next]');
      const saveBtn = form.querySelector('[data-quiz-save]');

      showStep = function (i, focus) {
        stepAt = Math.min(Math.max(i, 0), steps.length - 1);
        steps.forEach((s, n) => s.classList.toggle('is-active', n === stepAt));

        const last = stepAt === steps.length - 1;
        if (backBtn) backBtn.hidden = stepAt === 0;
        if (nextBtn) nextBtn.hidden = last;
        if (saveBtn) saveBtn.hidden = !last;

        const step = steps[stepAt];
        if (labelEl) labelEl.textContent = step.dataset.quizName || '';
        if (fillEl) fillEl.style.width = `${((stepAt + 1) / steps.length) * 100}%`;
        if (barEl) barEl.setAttribute('aria-valuenow', String(stepAt + 1));

        if (focus) {
          const h = step.querySelector('h2');
          if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
          step.scrollIntoView({ block: 'nearest', behavior: prefersReducedMotion ? 'auto' : 'smooth' });
        }
      };

      // only the visible step can be validated, so check it before moving on
      function stepValid() {
        const fields = [...steps[stepAt].querySelectorAll('input, select')];
        for (const el of fields) {
          if (!el.checkValidity()) { el.reportValidity(); return false; }
        }
        return true;
      }

      if (nextBtn) nextBtn.addEventListener('click', () => {
        if (stepValid()) showStep(stepAt + 1, true);
      });
      if (backBtn) backBtn.addEventListener('click', () => showStep(stepAt - 1, true));

      // Enter should advance rather than submit a half-filled profile
      form.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter' || e.target.tagName !== 'INPUT') return;
        if (stepAt === steps.length - 1) return;
        e.preventDefault();
        if (stepValid()) showStep(stepAt + 1, true);
      });

      showStep(0, false);
    }

    try {
      const saved = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (saved) { restore(saved); summarise(saved); if (panel) panel.classList.add('is-visible'); }
    } catch (_) {}

    form.addEventListener('submit', (e) => {
      e.preventDefault();

      // an invalid field on a hidden step can't report itself — go back to it
      const bad = [...form.querySelectorAll('input, select')].find((el) => !el.checkValidity());
      if (bad) {
        const owner = bad.closest('[data-quiz-step]');
        if (owner && !owner.classList.contains('is-active')) {
          showStep(steps.indexOf(owner), true);
        }
        bad.reportValidity();
        return;
      }

      const data = collect();
      try { localStorage.setItem(KEY, JSON.stringify(data)); } catch (_) {}
      summarise(data);
      if (panel) {
        panel.classList.add('is-visible');
        panel.scrollIntoView({ block: 'center', behavior: prefersReducedMotion ? 'auto' : 'smooth' });
      }
    });
  })();

  /* ---- footer year ---- */
  document.querySelectorAll('[data-year]').forEach((el) => {
    el.textContent = new Date().getFullYear();
  });
})();
